// extracted by mini-css-extract-plugin
export default {"ultimate_ttt_container":"styles_ultimate_ttt_container__KaM-h","ultimate_ttt_grid":"styles_ultimate_ttt_grid__AbI0b"};